export default [
  {
    path: '/galeria-fotos',
    name: 'galeriaFotos',
    component: () => import(/* webpackChunkName: "galeriaFotos" */ '../../views/galeriaFotos/GaleriaFotos')
  },
  {
    path: '/administracao-galeria-fotos',
    name: 'galeriaFotos-administracao',
    component: () => import(/* webpackChunkName: "galeriaFotos-administracao" */ '../../views/galeriaFotos/GaleriaFotosAdministracao')
  },
  {
    path: '/galeria-fotos/detalhes/:id',
    name: 'detalhes-galeriaFotos',
    component: () => import(/* webpackChunkName: "detalhes-galeriaFotos" */ '../../views/galeriaFotos/Detalhes')
  },
  {
    path: '/galeria-fotos/detalhes/:id',
    name: 'detalhes-administracao',
    component: () => import(/* webpackChunkName: "detalhes-administracao" */ '../../views/galeriaFotos/DetalhesAdministracao')
  },
  {
    path: '/galeria-fotos/cadastro',
    name: 'cadastro-galeriaFotos',
    component: () => import(/* webpackChunkName: "cadastro-galeriaFotos" */ '../../views/galeriaFotos/Cadastro')
  },
  {
    path: '/galeria-fotos/cadastro/:id',
    name: 'edicao-galeriaFotos',
    component: () => import(/* webpackChunkName: "edicao-galeriaFotos" */ '../../views/galeriaFotos/Cadastro')
  }
]
